import { Directive } from '@angular/core';

@Directive({
  selector: 'tab1',
  standalone: false,
})
export class Tab1Directive {}
